import { TelemetryProvider } from '../models/telemetry-provider';
import { Injectable } from '@angular/core';
import { DateUtility } from '../../date.utility';
import { TelemetryErrorEvent } from '../models/telemetry-error-event';
import { TelemetryPageViewEvent } from '../models/telemetry-page-view-event';
import { TelemetryEvent } from '../models/telemetry-event';

@Injectable({
	providedIn: 'root'
})
export class ConsoleTelemetryProvider extends TelemetryProvider {
	constructor(private dateUtility: DateUtility) {
		super();
	}

	trackError(event: TelemetryErrorEvent): void {
		console.error(`[${ event.timestamp })}]::[Telemetry Error]`, event);
	}

	trackEvent(event: TelemetryEvent): void {
		console.log(`[${ event.timestamp })}]::[Telemetry Event]`, event);
	}

	trackPageView(event: TelemetryPageViewEvent): void {
		console.log(`[${ event.timestamp })}]::[Telemetry PageViewEvent]`, event);
	}
}


